<template>
  <Layout>
  <component v-if="getRejectItem.name !== 'default'" :is="getRejectItem.component" />
  <DefaultHandler v-else :message="rejectData.message" />
  </Layout>
</template>

<script>
import { eventBus } from 'kaspi.frontend/src/modules/eventBus/eventBus'
import { sendAnalyticEvent } from '@/helpers/sendAnalyticEvent'

import HAS_TAX_DEBTS from './Fails/HAS_TAX_DEBTS.vue'
import KKID_MAX_AGE from './Fails/KKID_MAX_AGE.vue'
import KKID_MIN_AGE from './Fails/KKID_MIN_AGE.vue'
import KKID_MAX_CNT from './Fails/KKID_MAX_CNT.vue'
import KKID_ERR_PRNT_GLD from './Fails/KKID_ERR_PRNT_GLD.vue'
import CHECK_GRAY_LIST from './Fails/CHECK_GRAY_LIST.vue'
import KKID_ERR_GET_NALOGDB from './Fails/KKID_ERR_GET_NALOGDB.vue'
import KKID_DIFF_MOB_NUM from './Fails/KKID_DIFF_MOB_NUM.vue'
import CL_BAD_TAXPAYER from './Fails/CL_BAD_TAXPAYER.vue'
import FailedAlreadyExist from './Fails/FailedAlreadyExist.vue'
import DefaultHandler from './Fails/DefaultHandler.vue'
import CLIENT_POD_FT from './Fails/CLIENT_POD_FT.vue'
import BLACK_LIST_A7 from './Fails/BLACK_LIST_A7.vue'
import HAS_ARREST from './Fails/HAS_ARREST.vue'
import PHOTO_VER_REJECT from './Fails/PHOTO_VER_REJECT.vue'
import useHeader from '@/composables/useHeader'
import translate from "@/filters/translate.filter"
import Layout from '@/components/ui/Layout/Layout.vue'

export default {
  name: 'GoldkidOpenFailed',
  components: {
    Layout,
    KKID_MAX_AGE,
    KKID_MIN_AGE,
    KKID_MAX_CNT,
    HAS_TAX_DEBTS,
    CHECK_GRAY_LIST,
    BLACK_LIST_A7,
    KKID_DIFF_MOB_NUM,
    KKID_ERR_PRNT_GLD,
    KKID_ERR_GET_NALOGDB,
    CL_BAD_TAXPAYER,
    HAS_ARREST,
    FailedAlreadyExist,
    CLIENT_POD_FT,
    DefaultHandler,
    PHOTO_VER_REJECT
  },
  setup () {
    const {hideBackBtn, setTitle} = useHeader()
    hideBackBtn()
    setTitle(translate('title:goldkid'))
  },
  data () {
    return {
      rejectList: [
        {
          // ЭТОТ КОМПОНЕНТ НА САМОМ ДЕЛЕ ОТРАБАТЫВАЕТ ДЛЯ КОДА CL_BAD_TAXPAYER  © Расул
          name: 'HAS_TAX_DEBTS',
          component: 'HAS_TAX_DEBTS'
        },
        {
          name: 'KKID_MAX_AGE',
          component: 'KKID_MAX_AGE'
        },
        {
          name: 'KKID_ERR_PRNT_GLD',
          component: 'KKID_ERR_PRNT_GLD'
        },
        {
          name: 'KKID_MIN_AGE',
          component: 'KKID_MIN_AGE'
        },
        {
          name: 'KKID_MAX_CNT',
          component: 'KKID_MAX_CNT'
        },
        {
          name: 'CHECK_GRAY_LIST',
          component: 'CHECK_GRAY_LIST'
        },
        {
          name: 'KKID_ERR_GET_NALOGDB',
          component: 'KKID_ERR_GET_NALOGDB'
        },
        {
          name: 'KKID_DIFF_MOB_NUM',
          component: 'KKID_DIFF_MOB_NUM'
        },
        {
          name: 'CL_BAD_TAXPAYER',
          component: 'CL_BAD_TAXPAYER'
        },
        {
          name: 'BLACK_LIST_A7',
          component: 'BLACK_LIST_A7'
        },
        {
          name: 'IN_BLACK_LIST',
          component: 'BLACK_LIST_A7'
        },
        {
          name: 'CLIENT_POD_FT',
          component: 'CLIENT_POD_FT'
        },
        {
          name: 'HAS_ARREST',
          component: 'HAS_ARREST'
        },
        {
          name: 'FEW_KASPI_KID',
          component: 'FailedAlreadyExist'
        },
        {
          name: 'PHOTO_VER_REJECT',
          component: 'PHOTO_VER_REJECT'
        }
      ],
      rejectData: {
        message: ''
      }
    }
  },
  computed: {
    getRejectItem () {
      const rejectElem = this.rejectList.find(rejectItem => {
        return rejectItem.name === this.rejectData.rejectCode
      })

      if (rejectElem) return rejectElem
      return { name: 'default', component: 'DefaultHandler' }
    }
  },
  async created () {
    const response = await this.$store.dispatch('goldkidProcess/dataStep')
    this.rejectData = response?.data?.data || { message: '' }
    sendAnalyticEvent('online_child_gold_rejected', {
      started_from: [this.$store.getters['app/urlParams'].startedFrom],
      stage: ['start'],
      page_path: ['/bank/bpm/products/goldkids/goldkid'],
      reject_reason: [this.rejectData.message],
      external_message_id: [this.$store.getters['goldkidProcess/pId']]
    })

    // KAFKA LOGGER
    this.$store.dispatch('goldkidProcess/logEventToKafka', {
      ver: 1,
      usrId: this.$store.getters['goldkidProcess/userData']?.userId,
      evt: 'gold_kid_events',
      act: 'online_child_gold_rejected'
    })

    eventBus.$emit('kaspiLoading', false)
  }
}
</script>

<style>

</style>
